export default __webpack_public_path__ + "static/media/plain-sticker-t.c3339c37.png";